import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import Spinner from "../../shared/Spinner";

function Index() {
  const { username, sessionKey } = useParams();

  useEffect(() => {
    document.getElementById("submitForm").submit();
  }, []);

  return (
    <div>
      <Spinner />
      <div style={{ display: "none" }}>
        <form
          id="submitForm"
          action="https://storkph-epp-staging.azurewebsites.net/IFern/login"
          method="post"
          style={{
            display: "none",
          }}
        >
          <input name="username" value={username} />
          <input name="sessionKey" value={sessionKey} />
          <button type="submit" class="btn btn-primary">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}

export default Index;
